// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    webGetCtrlFeesAndLimits (params?: {}): Promise<Dict>;
    webGetEnDocsFees (params?: {}): Promise<Dict>;
    publicGetCurrency (params?: {}): Promise<List>;
    publicGetCurrencyListExtended (params?: {}): Promise<List>;
    publicGetOrderBook (params?: {}): Promise<Dict>;
    publicGetPairSettings (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<Dict>;
    publicGetCandlesHistory (params?: {}): Promise<Dict>;
    publicGetRequiredAmount (params?: {}): Promise<Dict>;
    publicGetPaymentsProvidersCryptoList (params?: {}): Promise<Dict | List>;
    privatePostUserInfo (params?: {}): Promise<Dict>;
    privatePostOrderCreate (params?: {}): Promise<Dict>;
    privatePostOrderCancel (params?: {}): Promise<Dict>;
    privatePostStopMarketOrderCreate (params?: {}): Promise<Dict>;
    privatePostStopMarketOrderCancel (params?: {}): Promise<Dict>;
    privatePostUserOpenOrders (params?: {}): Promise<Dict>;
    privatePostUserTrades (params?: {}): Promise<Dict>;
    privatePostUserCancelledOrders (params?: {}): Promise<List>;
    privatePostOrderTrades (params?: {}): Promise<Dict>;
    privatePostDepositAddress (params?: {}): Promise<Dict>;
    privatePostWithdrawCrypt (params?: {}): Promise<Dict>;
    privatePostWithdrawGetTxid (params?: {}): Promise<Dict>;
    privatePostExcodeCreate (params?: {}): Promise<Dict>;
    privatePostExcodeLoad (params?: {}): Promise<Dict>;
    privatePostCodeCheck (params?: {}): Promise<Dict>;
    privatePostWalletHistory (params?: {}): Promise<Dict>;
    privatePostWalletOperations (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderCreate (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderUpdate (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderCancel (params?: {}): Promise<Dict>;
    privatePostMarginUserPositionClose (params?: {}): Promise<Dict>;
    privatePostMarginUserPositionMarginAdd (params?: {}): Promise<Dict>;
    privatePostMarginUserPositionMarginRemove (params?: {}): Promise<Dict>;
    privatePostMarginCurrencyList (params?: {}): Promise<Dict>;
    privatePostMarginPairList (params?: {}): Promise<Dict>;
    privatePostMarginSettings (params?: {}): Promise<Dict>;
    privatePostMarginFundingList (params?: {}): Promise<Dict>;
    privatePostMarginUserInfo (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderList (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderHistory (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderTrades (params?: {}): Promise<Dict>;
    privatePostMarginUserOrderMaxQuantity (params?: {}): Promise<Dict>;
    privatePostMarginUserPositionList (params?: {}): Promise<Dict>;
    privatePostMarginUserPositionMarginRemoveInfo (params?: {}): Promise<Dict>;
    privatePostMarginUserPositionMarginAddInfo (params?: {}): Promise<Dict>;
    privatePostMarginUserWalletList (params?: {}): Promise<Dict>;
    privatePostMarginUserWalletHistory (params?: {}): Promise<Dict>;
    privatePostMarginUserTradeList (params?: {}): Promise<Dict>;
    privatePostMarginTrades (params?: {}): Promise<Dict>;
    privatePostMarginLiquidationFeed (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
